exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._26KWc {\n  position: absolute;\n  top: 2px;\n  right: 0;\n  padding: 10px 15px;\n  color: #A89A72;\n  cursor: pointer;\n}\n.ePNlY {\n  margin-top: 5px;\n  padding-top: 10px;\n  height: 450px;\n  overflow: auto;\n}\n.ePNlY ul {\n  margin: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"btnClear": "_26KWc",
	"list": "ePNlY"
};